import { DataTypeSearchCombo, SearchQuery } from '../Query';

export const isDataTypeSearchCombo = (
  query?: SearchQuery | DataTypeSearchCombo,
): query is DataTypeSearchCombo => !!query && 'dataType' in query;
